import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const NotifyProducerOfFilesReady = ({ readOnly, task, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    if (confirm(formatMessage(messages.notifyProducerConfirm))) {
      fetch(`/ordertask/notifyProducerAboutFilesReady.json?taskId=${task.uid}`, { 
        method: 'POST'
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          toastr.success(formatMessage(messages.notifyProducerSuccess))
        } else {
          toastr.error(formatMessage(messages.notifyProducerError, { errors: response.errors.join(', ') }))
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => {refetch()})
    }
  }

  return (
    <Menu.Item key='notifyProducer' disabled={readOnly || task?.producerIsNotified}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.notifyProducer) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default NotifyProducerOfFilesReady
